// extracted by mini-css-extract-plugin
module.exports = {"root":"ProcedureTabs_root__95DC5","tab":"ProcedureTabs_tab__131n0"};